import { IServiceFactory } from '../../common/types/service-factory';
import { ApiService, IApiService } from '../interfaces/api-service';

export class ApiServiceFactory implements IServiceFactory<IApiService> {
	public Create(): IApiService {
		return new ApiService();
	}
}
